<template>
  <div class="RelationshipView">
    <h2 class="gl_form-title">
      {{ t('rater.dental.relationship.form-legend') }}
    </h2>
    <CardInfoComponent>
      {{ configurations?.tags.relationshipAlert.label }}
    </CardInfoComponent>
    <RelationshipComponent
      v-model="insureds"
      :answers="answers"
      :configurations="configurations"
    />
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import CardInfoComponent from '@/modules/common/common/components/panels/CardInfoComponent.vue'
import RelationshipComponent from '@/modules/common/common/components/panels/RelationshipComponent.vue'
import DentalConfigurations from '@/modules/dental/common/models/APP/DentalConfigurations'
import DentalRaterAnswers from '@/modules/dental/rater/models/APP/DentalRaterAnswers'
import type Insured from '@/modules/common/common/models/APP/Insured'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

defineExpose({ triggerSubmit })

const props = defineProps({
  nextForm: {
    type: Array,
    required: true
  },
  answers: {
    type: DentalRaterAnswers,
    default: () => {}
  },
  configurations: {
    type: DentalConfigurations
  }
})

const insureds = ref<Insured[]>([...(props.answers.insureds ?? [])])

function triggerSubmit() {
  const page = props.nextForm[0]
  const answers = {
    insureds: insureds.value
  }

  return { page, answers }
}
</script>
